import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Sale, SaleFilter, SaleState} from "@/modules/sale/types";
import {getSale, getSales, saveRawSales, saveSales} from "@/services/sales";

export const state: SaleState = {
  sale: {
    id: "",
    unit_price: "",
    date: "",
    id_item: "",
    id_customer: ""
  }
}

const actions: ActionTree<SaleState, RootState> = {
  async GET_SALE(_, id) {
    return await getSale(id);
  },
  async GET_SALES(_, payload: SaleFilter) {
    return await getSales(payload);
  },
  async SAVE_SALES(_, sales: Sale[]) {
    return await saveSales(sales);
  },
  async SAVE_RAW_SALES(_, sales: Sale[]) {
    return await saveRawSales(sales);
  }
}

const mutations: MutationTree<SaleState> = {
  SET_SALE(state, sale: Sale) {
    state.sale = sale;
  }
}

const getters: GetterTree<SaleState, RootState> = {
  SALE(state): Sale {
    const {sale} = state;
    return {...sale};
  }
}

export const sale: Module<SaleState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
